/*
  ONJ CUSTOM — onj-similar-products.js
  Purpose:  Loads same-type + same-color-family products into the PDP "More like this" shell
  Consumed: sections/onj-similar-products.liquid (shell mode renders <onj-similar-products>)
  Added:    2026-10 · Horizon migration R1
  Round 2:  Retire with sections/onj-similar-products.liquid
*/
(() => {
  if (customElements.get('onj-similar-products')) return;

  class OnjSimilarProducts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      this.dataset.loaded = 'true';
      const shell = this.querySelector('[data-onj-similar-shell]');
      const target = this.querySelector('[data-onj-similar-target]');
      if (!shell || !target || !this.dataset.url) return;

      try {
        const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-onj-similar-results]');
        if (!results) return this.hide('no matching products (or Search & Discovery filters not enabled)');

        // Results include one extra item. Drop the current product if it came back,
        // otherwise drop the extra one, so the row is never short by one.
        const own = results.querySelectorAll(`[data-onj-product-id="${CSS.escape(this.dataset.productId || '')}"]`);
        const drop = own.length ? own : results.querySelectorAll('[data-onj-overflow]');
        drop.forEach((item) => (item.closest('slideshow-slide') || item).remove());

        if (!results.querySelector('[data-onj-product-id]')) return this.hide('only the current product matched');

        target.replaceChildren(document.importNode(results, true));
        shell.hidden = false;
      } catch (error) {
        this.hide(error.message);
      }
    }

    hide(reason) {
      const shell = this.querySelector('[data-onj-similar-shell]');
      if (shell && !window.Shopify?.designMode) shell.hidden = true;
      console.info('[onj-similar-products] hidden:', reason);
    }
  }

  customElements.define('onj-similar-products', OnjSimilarProducts);
})();
